import { render, staticRenderFns } from "./TankTypeDetail.vue?vue&type=template&id=4f31dc74&"
import script from "./TankTypeDetail.vue?vue&type=script&lang=js&"
export * from "./TankTypeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports